import noty from '@/plugins/noty'

export const leftNotification = noty({
  type: 'info',
  timeout: 3000,
  text: 'You’ve left the call'
})



// WEBPACK FOOTER //
// ./src/components/live-coach-call/toolbar/leave-button/notifications.js